import * as yup from 'yup';

export type UpdateVendorDto = {
  vendor?: string;
};

export const updateVendorSchema: yup.SchemaOf<UpdateVendorDto> = yup.object({
  vendor: yup.string(),
});
